import { IQualifier } from "../../model/formconfiguration/Qualifier";
import { IQualiferService } from "../../service/formconfiguration/QualifierService";

export default class CreateQualifierInteractor {
  private qualifierService: IQualiferService;

  constructor(qualifierService) {
    this.qualifierService = qualifierService;
  }

  async execute(qualifier: IQualifier, formTypeCode: string) {
    await this.qualifierService.createQualifier(qualifier, formTypeCode);
  }
}
